function injectStyle (ssrContext) {
  require("!!../../../../../../../.config/yarn/global/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"autoprefixer\":false,\"sourceMap\":true,\"minimize\":false}!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-d1779b96\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/selector?type=styles&index=0!./StarRating.vue")
}
var Component = require("!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"cacheDirectory\":true,\"babelrc\":false,\"presets\":[[\"/Users/Eugen/.config/yarn/global/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"useBuiltIns\":true}]]}!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/selector?type=script&index=0!./StarRating.vue"),
  /* template */
  require("!!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d1779b96\"}!../../../../../../../.config/yarn/global/node_modules/vue-loader/lib/selector?type=template&index=0!./StarRating.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/StarRating.vue
// module id = 205
// module chunks = 0